import { render, staticRenderFns } from "./NoSessions.vue?vue&type=template&id=b2889a48"
import script from "./NoSessions.vue?vue&type=script&lang=js"
export * from "./NoSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports